import Amplify from '@aws-amplify/core';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import App from 'App';
import { swRegister } from 'serviceWorker';
import { awsConfig, isDevelopment } from 'utils/constants/constants';
import 'assets/styles/main.scss';
import 'assets/styles/fonts.scss';

Amplify.configure(awsConfig);

if (!isDevelopment) {
  window.onload = () => {
    window.dataLayer = window.dataLayer || [];
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID!, dataLayerName: 'PageDataLayer' });
  };

  const DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (typeof DEV_TOOLS === 'object') {
    for (const [key, value] of Object.entries(DEV_TOOLS)) {
      DEV_TOOLS[key] = typeof value === 'function' ? () => undefined : null;
    }
  }
}

const root = createRoot(document.getElementById('root')!);

root.render(<App />);

swRegister();
